module.exports = __webpack_public_path__ + "img/162.8c4fe81b.jpg";